module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-swop bg-light"
  }, [(_vm.data) ? _c('div', [_c('div', {
    staticClass: "bg-white h-32 border-b border-solid border-gray-300 flex items-center"
  }, [_c('div', {
    staticClass: "container p-8 mx-auto"
  }, [_c('div', {
    staticClass: "md:flex md:items-center md:justify-between"
  }, [_c('div', {
    staticClass: "flex-1 min-w-0"
  }, [_c('h2', {
    staticClass: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate"
  }, [_vm._v("\n                            " + _vm._s(_vm.data.serial) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex mt-4 text-gray-500"
  }, [_c('div', {
    staticClass: "mr-6"
  }, [_c('i', {
    staticClass: "fas fa-box text-sm mr-1"
  }), _vm._v("\n                                " + _vm._s(_vm.data.container.name) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "mr-6"
  }, [_c('i', {
    staticClass: "fas fa-clock text-sm mr-1"
  }), _vm._v("\n                                " + _vm._s(_vm.timeFromNow(_vm.data.created_at)) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "mr-6"
  }, [_c('i', {
    staticClass: "fas fa-user text-sm mr-1"
  }), _vm._v("\n                                " + _vm._s(_vm.data.worker.name) + "\n                            ")]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fas fa-cog text-sm mr-1"
  }), _vm._v("\n                                " + _vm._s(_vm.data.parts.length) + "\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex md:mt-0 md:ml-4"
  }, [_c('span', {
    staticClass: "hidden sm:block ml-3 shadow-sm rounded-md"
  }, [_c('button', {
    staticClass: "inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:text-gray-800 active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showTestAlert = true
      }
    }
  }, [_vm._v("\n                                Udfør " + _vm._s(_vm.data.tests.length + 1) + ". test\n                            ")]), _vm._v(" "), (_vm.showTestAlert) ? _c('custom-alert', {
    attrs: {
      "heading": "Er du sikker?",
      "description": 'Du er ved at udføre <b>test #' + (_vm.data.tests.length + 1) + '</b>',
      "acceptText": "Ja",
      "cancelText": "Annullér"
    },
    on: {
      "cancel": function($event) {
        _vm.showTestAlert = false
      },
      "accept": function($event) {
        return _vm.test()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "ml-3 shadow-sm rounded-md"
  }, [_c('button', {
    staticClass: "bg-main border border-transparent inline-flex items-center px-4 py-2 text-sm leading-5 font-medium rounded-md text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.complete()
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_vm._v("\n                                    Afslut SWOP\n                                ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content overflow-y-auto",
    staticStyle: {
      "height": "calc(100vh - 12rem)",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('div', {
    staticClass: "container mx-auto p-8"
  }, [(_vm.data.available_parts.length > 0) ? _c('div', {
    staticClass: "flex flex-wrap -mx-4 -mb-8"
  }, _vm._l((_vm.data.available_parts), function(part) {
    return _c('div', {
      key: part.id,
      staticClass: "h-32 w-1/3 px-4 mb-8 outline-none focus:outline-none hover:outline-none"
    }, [_c('div', {
      staticClass: "part-card cursor-pointer relative h-full flex items-center overflow-hidden bg-white shadow rounded py-4 px-6",
      class: {
        'selected': part.count > 0
      },
      on: {
        "click": function($event) {
          return _vm.addPart(part)
        }
      }
    }, [_c('div', [_c('div', {
      staticClass: "text-xl font-semibold mb-2 text-gray-900 leading-tight"
    }, [_vm._v("\n                                    " + _vm._s(part.name) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-500"
    }, [(part.count > 0) ? _c('span', [_c('span', {
      staticClass: "text-main"
    }, [_vm._v(_vm._s(part.count) + " stk")]), _vm._v(" |\n                                    ")]) : _vm._e(), _vm._v("\n                                    " + _vm._s(part.number) + "\n                                ")]), _vm._v(" "), (part.count > 0) ? _c('div', {
      staticClass: "remove-part-btn absolute bottom-0 right-0 h-10 w-16 text-sm text-white flex items-center justify-center",
      on: {
        "click": function($event) {
          return _vm.removePart(part)
        }
      }
    }, [_vm._v("\n                                    Fjern\n                                ")]) : _vm._e()])])])
  }), 0) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6525190c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/singleSwop.vue
// module id = 289
// module chunks = 1